/**
 * Gift Experience – Form behaviour
 * ● Variant radio toggle
 * ● Quantity +/- buttons
 * ● AJAX add-to-cart (falls back to normal submit)
 */
(function () {
  document.querySelectorAll('.ge-form').forEach(initForm);

  function initForm(form) {
    /* ── Variant radios ── */
    const variantInputs = form.querySelectorAll('input[name="id"]');
    variantInputs.forEach((input) => {
      input.addEventListener('change', () => {
        form.querySelectorAll('.ge-variant-option').forEach((opt) =>
          opt.classList.toggle('ge-variant-option--active', opt.contains(input))
        );
      });
    });

    /* ── Quantity +/- ── */
    form.querySelectorAll('.ge-qty-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = form.querySelector('.ge-qty-input');
        let val = parseInt(input.value, 10) || 1;
        if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
        if (btn.dataset.action === 'plus') val += 1;
        input.value = val;
      });
    });

    /* ── AJAX submit ── */
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const submitBtn = form.querySelector('.ge-submit');
      const spinner = submitBtn.querySelector('.loading__spinner');
      const label = submitBtn.querySelector('span');

      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
      if (label) label.style.visibility = 'hidden';

      try {
        const formData = new FormData(form);
        const body = {
          items: [
            {
              id: parseInt(formData.get('id'), 10),
              quantity: parseInt(formData.get('quantity'), 10) || 1,
              properties: {}
            }
          ]
        };

        // Gather line-item properties
        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[')) {
            body.items[0].properties[key.replace('properties[', '').replace(']', '')] = value;
          }
        }

        const res = await fetch(
          (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body),
            credentials: 'same-origin'
          }
        );

        const data = await res.json();

        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Error al añadir al carrito');
        }

        // Update cart count bubble
        const cartBubble = document.querySelector('.cart-count-bubble');
        if (cartBubble) {
          const countEl = cartBubble.querySelector('[data-cart-count]') || cartBubble.querySelector('span');
          if (countEl) {
            const currentCount = parseInt(countEl.textContent, 10) || 0;
            countEl.textContent = currentCount + (parseInt(formData.get('quantity'), 10) || 1);
            cartBubble.classList.remove('hidden');
          }
        }

        // Try to open cart drawer / notification
        const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          // Fetch fresh sections for drawer
          const sectionsUrl = `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`;
          fetch(sectionsUrl)
            .then((r) => r.json())
            .then((sections) => {
              cartDrawer.renderContents({ sections });
            })
            .catch(() => {});
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
        } else {
          // Fallback: redirect to cart
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error('[GiftExperience]', err);
        alert(err.message);
      } finally {
        submitBtn.removeAttribute('aria-disabled');
        submitBtn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        if (label) label.style.visibility = '';
      }
    });
  }
})();
